import Button from "components/Button/Button";
import React from "react";
import { AiOutlineCalendar, AiOutlineEnvironment } from "react-icons/ai";
import { Link } from "react-router-dom";
import sideYellow from "images/pattern/side-yellow.svg";
import sideYellowBigger from "images/pattern/side-yellow-bigger.svg";
import sideRed from "images/pattern/side-red.svg";
import dotsBlue from "images/pattern/dots-blue.svg";
import circleQuarter from "images/pattern/circle-quarter.svg";
import waveRed from "images/pattern/wave-red.svg";
import dotsRedRandom from "images/pattern/dots-red-random.svg";

const EventLayout = ({
  children,
  event,
  isLoading,
  isAuth = false,
  isJoin = false,
  isClosed = false,
  isBig = false,
}) => {
  return (
    <div className="bg-wce-pink-light py-11 px-6 md:pt-18 md:pb-32 md:px-16 flex justify-between flex-1 overflow-hidden relative">
      <div className="flex flex-col items-center md2:items-start">
        <div className="w-fit relative z-10">
          <div
            className="inline-flex items-center bg-wce-yellow-light py-2 md2:py-4 px-4 md2:px-6 rounded-3xl text-center
          font-yesevaOne text-wce-navy text-2xl sm:text-4xl md2:text-6.5xl min-h-[48px] sm:min-h-[80px] md2:min-h-[112px] w-fit mb-10"
          >
            {event.title}
          </div>
          <div className="absolute -right-4 -bottom-4 translate-x-1/2 hidden md2:block">
            <img
              className="w-[140px] min-w-[140px]"
              src={waveRed}
              alt={"waveRed"}
            />
          </div>
        </div>
        <div className="flex flex-col-reverse md2:flex-row justify-between gap-10 items-center">
          <div className="flex flex-col w-full md2:w-2/3 z-10">
            <div className="flex flex-col gap-2 text-lg text-wce-navy">
              <div className="flex gap-2">
                <AiOutlineCalendar size={24} />
                <div>{event.date}</div>
              </div>
              <div className="flex gap-2">
                <AiOutlineEnvironment size={24} />
                <div>{event.location}</div>
              </div>
            </div>
            <div className="mt-6 text-lg text-wce-neutral-9">
              {event.description}
            </div>
            <div className="absolute left-[300px] bottom-3 hidden md2:block">
              <img
                className="w-[120px] min-w-[120px]"
                src={dotsRedRandom}
                alt={"dotsRedRandom"}
              />
            </div>
            {isLoading && isAuth ? (
              ""
            ) : (
              <div>
                <Link
                  to={
                    isJoin || isClosed
                      ? ""
                      : isAuth
                      ? `${event.link}/registration`
                      : `/login?next=${event.link}`
                  }
                >
                  <Button
                    className="min-w-[160px] mt-6"
                    size="large"
                    rounded
                    color="danger"
                    disabled={isJoin || isClosed}
                    responsive={false}
                  >
                    {isJoin
                      ? "You’ve Registered to This Event"
                      : isClosed
                      ? "Registration has been closed"
                      : isAuth
                      ? "Register Now"
                      : "Login to Register"}
                  </Button>
                </Link>
              </div>
            )}
          </div>
          <div className="flex relative">
            <div className="absolute -right-10 bottom-0">
              <img
                className="w-[80px] min-w-[80px] xs:w-[140px] xs:min-w-[140px]"
                src={dotsBlue}
                alt={"dotsBlue"}
              />
            </div>
            <div className="self-center max-w-[160px] xs:max-w-[280px] z-10">
              <img src={event.iconFill} alt="event" className="w-full" />
            </div>
            <div className="absolute -left-10 top-0">
              <img
                className="w-[80px] min-w-[80px] xs:w-[140px] xs:min-w-[140px]"
                src={dotsBlue}
                alt={"dotsBlue"}
              />
            </div>
          </div>
        </div>
        <div className="z-10 w-full">{children}</div>
        {isBig ? (
          <div className="hidden sm:block absolute left-0 translate-y-1/2 md:translate-y-0 bottom-0 w-full">
            <img
              className="w-full"
              src={sideYellowBigger}
              alt={"sideYellowBigger"}
            />
          </div>
        ) : (
          <div className="absolute left-0 translate-y-1/2 md:translate-y-0 bottom-0">
            <img
              className="w-[164px] min-w-[164px]"
              src={sideYellow}
              alt={"sideYellow"}
            />
          </div>
        )}
        <div className="absolute right-0 top-0">
          <img
            className="w-[137px] min-w-[137px]"
            src={sideRed}
            alt={"sideRed"}
          />
        </div>
        <div className="absolute bottom-0 left-1/2 -translate-x-1/2 hidden md:block">
          <img
            className="w-[281px] min-w-[281px]"
            src={circleQuarter}
            alt={"circleQuarter"}
          />
        </div>
      </div>
    </div>
  );
};

export default EventLayout;
